import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UtilsService } from 'src/app/core/services/utils/utils.service';

@Component({
  selector: 'cc-images',
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.scss'],
})
export class ImagesComponent implements OnInit {

  @Input() imgs;
  @Input() imagesAvailible: boolean = true;
  @Output() clickedImg = new EventEmitter<string>();
  @Output() tapedImg = new EventEmitter<string>();


  constructor(
    private utils: UtilsService
  ) { }

  ngOnInit() {
    if (this.imgs[0].url) {
      this.imgs.map(el => {
        const img = this.utils.getImage(el.extension);
        if (img)
          el.icon = img
        return el;
      })
    }

    this.imgs = this.imgs.map(el => {
      el.imgLoader = true;
      return el;
    })
  }

  handleImg(index) {
    this.clickedImg.emit(this.imgs[index]);
  }

  tapImage(index) {
    this.tapedImg.emit(this.imgs[index]);
  }

}
